var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-flex",
        { attrs: { md12: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.isFormValid,
                    callback: function($$v) {
                      _vm.isFormValid = $$v
                    },
                    expression: "isFormValid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Establecer Tiempos" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm12: "",
                                md12: "",
                                wrap: "",
                                layout: ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  attrs: {
                                    xs12: "",
                                    sm6: "",
                                    md6: "",
                                    "wrapper-files": ""
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        display: "flex",
                                        "margin-left": "5%"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md3: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Tiempo Negativo",
                                              "single-line": "",
                                              type: "number",
                                              "persistent-hint": true,
                                              hint:
                                                "El valor introducido define el tiempo en minutos, sin transmitir para mostrar en ROJO el dispositivo/vehículo"
                                            },
                                            model: {
                                              value: _vm.redTime,
                                              callback: function($$v) {
                                                _vm.redTime = $$v
                                              },
                                              expression: "redTime"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs12: "", sm6: "", md3: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Tiempo Preventivo",
                                              "single-line": "",
                                              type: "number",
                                              "persistent-hint": true,
                                              hint:
                                                "El valor introducido define el tiempo en minutos, sin transmitir para mostrar en AMARILLO el dispositivo/vehículo"
                                            },
                                            model: {
                                              value: _vm.yellowTime,
                                              callback: function($$v) {
                                                _vm.yellowTime = $$v
                                              },
                                              expression: "yellowTime"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            wrap: "",
                            layout: ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm6: "",
                                md6: "",
                                "wrapper-files": ""
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    display: "flex",
                                    "justify-content": "flex-end"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: { height: "47px" },
                                      attrs: { color: "#ffe800" },
                                      on: { click: _vm.handleClick }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Guardar\n                "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: { height: "47px" },
                                      attrs: { color: "#ffe800" },
                                      on: { click: _vm.cleanInput }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Limpiar\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }